/* ESENCIA · Guía de bienestar. Formulario por pasos que envía las respuestas a Make. */
(function () {
  'use strict';

  var root = document.querySelector('[data-gb]');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-gb-config]').textContent); } catch (e) { cfg = {}; }
  var lang = cfg.lang === 'en' ? 'en' : 'es';
  var STORE_KEY = 'esc_guia_bienestar_v1';

  /* Textos de interfaz */
  var UI = {
    es: {
      back: 'Atrás', next: 'Continuar', start: 'Empezar', send: 'Recibir mi guía', sending: 'Enviando',
      eyebrow: 'Experiencia ESENCIA',
      welcomeTitle: 'Tu guía de bienestar',
      welcomeText: 'Unas pocas preguntas sobre tu día a día. Con ellas y tu medición PRYSM iO preparamos una guía pensada solo para ti.',
      welcomeText2: 'Tómate tu tiempo. No hay respuestas correctas, solo tu momento de hoy.',
      welcomeNote: 'Te llevará unos cinco minutos.',
      aboutEyebrow: 'Sobre ti', aboutTitle: 'Empecemos por ti',
      nombre: 'Nombre', apellidos: 'Apellidos', email: 'Correo electrónico', edad: 'Edad', ciudad: 'Ciudad de la experiencia',
      emailHint: 'Usa el mismo correo con el que reservaste tu experiencia. Ahí recibirás tu guía.',
      sexo: 'Sexo', mujer: 'Mujer', hombre: 'Hombre',
      other: 'Cuéntanos cuál', optional: 'Opcional',
      scoreEyebrow: 'Tu medición', scoreTitle: 'Tu resultado PRYSM iO',
      scoreText: 'Escribe el número que te ha mostrado el equipo después de tu medición.',
      consent: 'Acepto que ESENCIA use mis respuestas para preparar mi guía personalizada.',
      privacy: 'Política de privacidad',
      summary: 'Enviaremos tu guía a',
      doneEyebrow: 'Gracias', doneTitle: 'Gracias, {name}',
      doneText: 'Tu guía ya se está preparando. En unos minutos llegará a tu correo.',
      doneText2: 'Si no la ves, revisa la carpeta de promociones o de correo no deseado.',
      doneText3: 'Ahora vuelve a la experiencia. Este momento es para ti.',
      errRequired: 'Esta respuesta nos ayuda a preparar tu guía.',
      errChoose: 'Elige una opción para continuar.',
      errName: 'Escribe tu nombre y tus apellidos.',
      errEmail: 'Revisa tu correo, parece que falta algo.',
      errAge: 'Escribe tu edad en números.',
      errCity: 'Escribe la ciudad de la experiencia.',
      errSexo: 'Elige una opción.',
      errScore: 'Escribe tu resultado en números, tal como aparece en la medición.',
      errConsent: 'Necesitamos tu permiso para preparar la guía.',
      errNetwork: 'No hemos podido enviar tus respuestas. Revisa tu conexión e inténtalo de nuevo. Tus respuestas siguen guardadas.'
    },
    en: {
      back: 'Back', next: 'Continue', start: 'Begin', send: 'Receive my guide', sending: 'Sending',
      eyebrow: 'ESENCIA Experience',
      welcomeTitle: 'Your wellbeing guide',
      welcomeText: 'A few questions about your everyday life. With them and your PRYSM iO reading, we prepare a guide made just for you.',
      welcomeText2: 'Take your time. There are no right answers, only how you are today.',
      welcomeNote: 'It takes about five minutes.',
      aboutEyebrow: 'About you', aboutTitle: 'Let us begin with you',
      nombre: 'First name', apellidos: 'Surname', email: 'Email', edad: 'Age', ciudad: 'City of the experience',
      emailHint: 'Use the same email you booked your experience with. Your guide will arrive there.',
      sexo: 'Sex', mujer: 'Woman', hombre: 'Man',
      other: 'Tell us which', optional: 'Optional',
      scoreEyebrow: 'Your reading', scoreTitle: 'Your PRYSM iO result',
      scoreText: 'Enter the number the team showed you after your reading.',
      consent: 'I agree that ESENCIA may use my answers to prepare my personal guide.',
      privacy: 'Privacy policy',
      summary: 'We will send your guide to',
      doneEyebrow: 'Thank you', doneTitle: 'Thank you, {name}',
      doneText: 'Your guide is being prepared. It will reach your inbox in a few minutes.',
      doneText2: 'If you cannot see it, check your promotions or spam folder.',
      doneText3: 'Now return to the experience. This moment is yours.',
      errRequired: 'This answer helps us prepare your guide.',
      errChoose: 'Choose an option to continue.',
      errName: 'Please enter your first name and surname.',
      errEmail: 'Please check your email, something seems to be missing.',
      errAge: 'Please enter your age in numbers.',
      errCity: 'Please enter the city of the experience.',
      errSexo: 'Choose an option.',
      errScore: 'Enter your result in numbers, exactly as shown in your reading.',
      errConsent: 'We need your permission to prepare your guide.',
      errNetwork: 'We could not send your answers. Check your connection and try again. Your answers are still saved.'
    }
  }[lang];

  /* Preguntas. El valor que se envía es siempre el texto en español, igual que en el formulario anterior. */
  var Q = [
    { key: 'frutas_verduras', type: 'single', sec: ['Alimentación', 'Nutrition'],
      q: ['¿Cuántas porciones de frutas y verduras consumes al día?', 'How many portions of fruit and vegetables do you eat a day?'],
      opts: [['0-1', '0-1'], ['2-3', '2-3'], ['4-5', '4-5'], ['Más de 5', 'More than 5']] },
    { key: 'colores', type: 'multi', sec: ['Alimentación', 'Nutrition'],
      q: ['¿Qué colores predominan más en tu alimentación habitual?', 'Which colours appear most in your usual diet?'],
      hint: ['Puedes elegir varios.', 'You can choose several.'],
      opts: [['Verde', 'Green'], ['Naranja / amarillo', 'Orange / yellow'], ['Rojo', 'Red'], ['Morado / azul', 'Purple / blue'], ['Blanco', 'White'], ['Casi ninguno de los anteriores', 'Hardly any of these']],
      exclusive: 'Casi ninguno de los anteriores' },
    { key: 'ultraprocesados', type: 'single', sec: ['Alimentación', 'Nutrition'],
      q: ['¿Con qué frecuencia consumes alimentos ultraprocesados?', 'How often do you eat ultra processed food?'],
      opts: [['A diario', 'Every day'], ['Varias veces por semana', 'Several times a week'], ['Ocasionalmente', 'Occasionally'], ['Casi nunca', 'Hardly ever']] },
    { key: 'agua', type: 'single', sec: ['Hidratación', 'Hydration'],
      q: ['¿Cuánta agua bebes aproximadamente al día?', 'Roughly how much water do you drink a day?'],
      opts: [['Menos de 1 litro', 'Less than 1 litre'], ['1–1,5 litros', '1 to 1.5 litres'], ['Más de 1,5 litros', 'More than 1.5 litres']] },
    { key: 'estres', type: 'single', sec: ['Tu ritmo', 'Your rhythm'],
      q: ['¿Cómo describirías tu nivel de estrés habitual?', 'How would you describe your usual stress level?'],
      opts: [['Bajo', 'Low'], ['Medio', 'Medium'], ['Alto', 'High']] },
    { key: 'sueno', type: 'single', sec: ['Descanso', 'Rest'],
      q: ['¿Cuántas horas duermes normalmente por noche?', 'How many hours do you usually sleep a night?'],
      opts: [['Menos de 6 horas', 'Less than 6 hours'], ['De 6 a 7 horas', '6 to 7 hours'], ['De 7 a 8 horas', '7 to 8 hours'], ['Más de 8 horas', 'More than 8 hours']] },
    { key: 'actividad', type: 'single', sec: ['Movimiento', 'Movement'],
      q: ['¿Cuál es tu actividad física habitual?', 'What is your usual physical activity?'],
      opts: [['Sedentario', 'Mostly sedentary'], ['1–2 veces por semana', '1 to 2 times a week'], ['3 o más veces por semana', '3 or more times a week']] },
    { key: 'fuma', type: 'single', sec: ['Hábitos', 'Habits'],
      q: ['¿Fumas actualmente?', 'Do you currently smoke?'],
      opts: [['No', 'No'], ['Sí', 'Yes'], ['Fumador social, esporádicamente', 'Socially, now and then']] },
    { key: 'suplementos', type: 'single', sec: ['Hábitos', 'Habits'],
      q: ['¿Tomas actualmente suplementos nutricionales de forma regular?', 'Do you take nutritional supplements regularly?'],
      opts: [['Sí', 'Yes'], ['No', 'No']] },
    { key: 'tipo_suplementos', type: 'textarea', sec: ['Hábitos', 'Habits'], when: function (a) { return a.suplementos === 'Sí'; },
      q: ['¿Qué tipo de suplementos tomas?', 'Which supplements do you take?'],
      hint: ['Por ejemplo, colágeno, magnesio u omega 3.', 'For example collagen, magnesium or omega 3.'] },
    { key: 'tratamiento', type: 'single', sec: ['Tu salud', 'Your health'],
      q: ['¿Actualmente estás bajo tratamiento médico o atravesando alguna condición de salud específica?', 'Are you currently under medical treatment or going through a specific health condition?'],
      opts: [['No', 'No'], ['Sí, estoy actualmente bajo tratamiento médico', 'Yes, I am currently under medical treatment'], ['Sí, convivo con una condición crónica', 'Yes, I live with a chronic condition'], ['Prefiero no decirlo', 'I prefer not to say']] },
    { key: 'situaciones', type: 'multi', sec: ['Tu salud', 'Your health'], when: function (a) { return /^Sí/.test(a.tratamiento || ''); },
      q: ['¿Cuál de las siguientes situaciones se aplica a ti?', 'Which of these situations applies to you?'],
      hint: ['Puedes elegir varias.', 'You can choose several.'],
      opts: [['Tratamiento hormonal', 'Hormonal treatment'], ['Enfermedad autoinmune', 'Autoimmune condition'], ['Tratamiento con antibióticos (actual o en los últimos 3 meses)', 'Antibiotics (now or in the last 3 months)'], ['Medicación antiinflamatoria o inmunosupresora', 'Anti inflammatory or immunosuppressant medication'], ['Problema digestivo que afecta a la absorción de nutrientes', 'Digestive issue affecting nutrient absorption'], ['__otro', 'Other']],
      otherLabel: ['Otra', 'Other'] },
    { key: 'energia', type: 'single', sec: ['Tu salud', 'Your health'],
      q: ['¿Sientes que actualmente tu nivel de energía, digestión o capacidad de recuperación está reducido?', 'Do you feel your energy, digestion or ability to recover is currently reduced?'],
      opts: [['No', 'No'], ['Ligeramente', 'Slightly'], ['Moderadamente', 'Moderately'], ['Significativamente', 'Significantly']] },
    { key: 'convivencia', type: 'multi', sec: ['Tu entorno', 'Your circle'],
      q: ['¿Tienes hijos u otras personas en casa que cuiden su salud contigo?', 'Do you have children or others at home who look after their health with you?'],
      hint: ['Puedes elegir varias.', 'You can choose several.'],
      opts: [['Hijos', 'Children'], ['Pareja', 'Partner'], ['Padres', 'Parents'], ['Ninguno de los anteriores', 'None of these']],
      exclusive: 'Ninguno de los anteriores' },
    { key: 'momento_vital', type: 'multi', sec: ['Tu momento', 'Your moment'],
      q: ['¿Está ocurriendo algo en tu vida en este momento que pueda estar influyendo en tu bienestar?', 'Is anything happening in your life right now that may be affecting your wellbeing?'],
      hint: ['Puedes elegir varias.', 'You can choose several.'],
      opts: [['Estrés elevado o continuado', 'High or ongoing stress'], ['Un cambio reciente importante (mudanza, cambio de trabajo, etc.)', 'A recent big change (a move, a new job and so on)'], ['Retos emocionales (por ejemplo, separación, duelo, ansiedad)', 'Emotional challenges (separation, grief or anxiety, for example)'], ['Preocupaciones relacionadas con la salud (mías o de alguien cercano)', 'Health worries (mine or someone close)'], ['Estrés ocasional, pero en general me siento bien', 'Occasional stress, but I generally feel well'], ['No', 'No'], ['Prefiero no decirlo', 'I prefer not to say'], ['__otro', 'Other']],
      otherLabel: ['Otro', 'Other'], exclusive: ['No', 'Prefiero no decirlo'] },
    { key: 'mejorar', type: 'textarea', optional: true, sec: ['Tu intención', 'Your intention'],
      q: ['¿Hay algo que te gustaría mejorar especialmente de tu bienestar?', 'Is there anything in particular you would like to improve in your wellbeing?'] }
  ];
  var L = lang === 'en' ? 1 : 0;

  /* Estado */
  var params = new URLSearchParams(window.location.search);
  var cityFromUrl = (params.get('ciudad') || params.get('city') || cfg.city || '').trim();
  var answers = load() || {};
  if (params.get('email') && !answers.email) answers.email = params.get('email').trim();
  if (cityFromUrl) answers.ciudad = cityFromUrl;
  var startedAt = Date.now();
  var sending = false;

  var stepsEl = root.querySelector('[data-gb-steps]');
  var backBtn = root.querySelector('[data-gb-back]');
  var countEl = root.querySelector('[data-gb-count]');
  var barEl = root.querySelector('[data-gb-bar]');

  /* Utilidades */
  function el(tag, attrs, html) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') n.className = attrs[k]; else if (attrs[k] !== null && attrs[k] !== undefined) n.setAttribute(k, attrs[k]);
    });
    if (html !== undefined) n.innerHTML = html;
    return n;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function save() { try { localStorage.setItem(STORE_KEY, JSON.stringify(answers)); } catch (e) {} }
  function load() { try { return JSON.parse(localStorage.getItem(STORE_KEY)); } catch (e) { return null; } }
  function clearStore() { try { localStorage.removeItem(STORE_KEY); } catch (e) {} }
  function setError(stepEl, msg) { var e = stepEl.querySelector('.gb__error'); if (e) e.textContent = msg || ''; }

  /* Construcción de pasos */
  var steps = [];

  function stepShell(id, eyebrow, title, isQuestion) {
    var s = el('section', { class: 'gb__step', 'data-step': id, 'aria-live': 'polite' });
    if (eyebrow) s.appendChild(el('p', { class: 'gb__eyebrow' }, esc(eyebrow)));
    if (title) s.appendChild(el(isQuestion ? 'h2' : 'h1', { class: isQuestion ? 'gb__q' : 'gb__title', tabindex: '-1' }, esc(title)));
    return s;
  }
  function actions(label, onClick, note) {
    var a = el('div', { class: 'gb__actions' });
    var b = el('button', { type: 'button', class: 'gb__btn' }, esc(label));
    b.addEventListener('click', onClick);
    a.appendChild(b);
    if (note) a.appendChild(el('p', { class: 'gb__note' }, esc(note)));
    return a;
  }

  // Bienvenida
  (function () {
    var s = stepShell('welcome', UI.eyebrow, UI.welcomeTitle);
    if (cfg.logo) s.insertBefore(el('img', { class: 'gb__logo', src: cfg.logo, alt: 'ESENCIA', width: '300', height: '80' }), s.firstChild);
    s.appendChild(el('p', { class: 'gb__text' }, esc(UI.welcomeText)));
    s.appendChild(el('p', { class: 'gb__text' }, esc(UI.welcomeText2)));
    s.appendChild(actions(UI.start, function () { go(1); }, UI.welcomeNote));
    steps.push({ id: 'welcome', el: s, progress: false });
  })();

  // Sobre ti
  (function () {
    var s = stepShell('about', UI.aboutEyebrow, UI.aboutTitle);
    function field(key, label, type, extra) {
      var f = el('div', { class: 'gb__field' });
      f.appendChild(el('label', { class: 'gb__label', for: 'gb-' + key }, esc(label)));
      var i = el('input', Object.assign({ id: 'gb-' + key, class: 'gb__input', type: type || 'text', name: key }, extra || {}));
      i.value = answers[key] || '';
      i.addEventListener('input', function () { answers[key] = i.value.trim(); save(); });
      f.appendChild(i);
      return f;
    }
    s.appendChild(field('nombre', UI.nombre, 'text', { autocomplete: 'given-name' }));
    s.appendChild(field('apellidos', UI.apellidos, 'text', { autocomplete: 'family-name' }));
    var ef = field('email', UI.email, 'email', { autocomplete: 'email', inputmode: 'email', autocapitalize: 'off', spellcheck: 'false' });
    ef.appendChild(el('p', { class: 'gb__hint', style: 'margin:8px 0 0' }, esc(UI.emailHint)));
    s.appendChild(ef);
    s.appendChild(field('edad', UI.edad, 'text', { inputmode: 'numeric', pattern: '[0-9]*', maxlength: '3' }));
    if (!cityFromUrl) s.appendChild(field('ciudad', UI.ciudad, 'text'));

    var sx = el('div', { class: 'gb__field' });
    sx.appendChild(el('span', { class: 'gb__label' }, esc(UI.sexo)));
    var og = el('div', { class: 'gb__options gb__options--two', role: 'radiogroup', style: 'margin-top:0' });
    [['Mujer', UI.mujer], ['Hombre', UI.hombre]].forEach(function (o) {
      var lab = el('label', { class: 'gb__opt' });
      var inp = el('input', { type: 'radio', name: 'sexo', value: o[0] });
      if (answers.sexo === o[0]) inp.checked = true;
      inp.addEventListener('change', function () { answers.sexo = o[0]; save(); });
      lab.appendChild(inp); lab.appendChild(el('span', null, esc(o[1])));
      og.appendChild(lab);
    });
    sx.appendChild(og);
    s.appendChild(sx);
    s.appendChild(el('p', { class: 'gb__error', role: 'alert' }));
    s.appendChild(actions(UI.next, function () {
      var err = '';
      if (!answers.nombre || !answers.apellidos) err = UI.errName;
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(answers.email || '')) err = UI.errEmail;
      else if (!/^\d{1,3}$/.test(answers.edad || '') || +answers.edad < 14 || +answers.edad > 110) err = UI.errAge;
      else if (!answers.ciudad) err = UI.errCity;
      else if (!answers.sexo) err = UI.errSexo;
      setError(s, err);
      if (!err) next();
    }));
    steps.push({ id: 'about', el: s, progress: true });
  })();

  // Preguntas
  Q.forEach(function (q) {
    var s = stepShell(q.key, q.sec[L], q.q[L], true);
    if (q.hint) s.appendChild(el('p', { class: 'gb__hint' }, esc(q.hint[L])));
    if (q.optional) s.appendChild(el('p', { class: 'gb__hint' }, esc(UI.optional)));

    if (q.type === 'single' || q.type === 'multi') {
      var stored = answers['_' + q.key] || [];
      var otherText = answers['_' + q.key + '_otro'] || '';
      var box = el('div', { class: 'gb__options', role: q.type === 'single' ? 'radiogroup' : 'group' });
      var otherInput = null;
      q.opts.forEach(function (o) {
        var lab = el('label', { class: 'gb__opt' });
        var inp = el('input', { type: q.type === 'single' ? 'radio' : 'checkbox', name: q.key, value: o[0] });
        if (stored.indexOf(o[0]) > -1) inp.checked = true;
        lab.appendChild(inp);
        lab.appendChild(el('span', null, esc(o[0] === '__otro' ? (q.otherLabel ? q.otherLabel[L] : o[1]) : o[L])));
        box.appendChild(lab);
        inp.addEventListener('change', function () {
          var excl = [].concat(q.exclusive || []);
          if (q.type === 'multi' && inp.checked) {
            var isEx = excl.indexOf(o[0]) > -1;
            box.querySelectorAll('input').forEach(function (other) {
              if (other === inp) return;
              if (isEx || excl.indexOf(other.value) > -1) other.checked = false;
            });
          }
          collect();
          if (q.type === 'single' && o[0] !== '__otro') setTimeout(function () { if (current === stepIndex(q.key)) next(); }, 380);
        });
      });
      s.appendChild(box);
      if (q.opts.some(function (o) { return o[0] === '__otro'; })) {
        otherInput = el('input', { class: 'gb__input gb__other', type: 'text', placeholder: UI.other, 'aria-label': UI.other });
        otherInput.value = otherText;
        otherInput.hidden = stored.indexOf('__otro') === -1;
        otherInput.addEventListener('input', collect);
        s.appendChild(otherInput);
      }
      var collect = function () {
        var vals = [].map.call(box.querySelectorAll('input:checked'), function (i) { return i.value; });
        answers['_' + q.key] = vals;
        if (otherInput) {
          otherInput.hidden = vals.indexOf('__otro') === -1;
          answers['_' + q.key + '_otro'] = otherInput.value.trim();
        }
        var out = vals.filter(function (v) { return v !== '__otro'; });
        if (otherInput && vals.indexOf('__otro') > -1 && otherInput.value.trim()) out.push(otherInput.value.trim());
        answers[q.key] = out.join(', ');
        setError(s, '');
        save();
      };
      s.appendChild(el('p', { class: 'gb__error', role: 'alert' }));
      s.appendChild(actions(UI.next, function () {
        collect();
        var vals = answers['_' + q.key] || [];
        if (!vals.length) return setError(s, UI.errChoose);
        if (vals.indexOf('__otro') > -1 && !(answers['_' + q.key + '_otro'])) return setError(s, UI.errRequired);
        next();
      }));
    } else {
      var t = el('textarea', { class: 'gb__textarea', name: q.key, 'aria-label': q.q[L], rows: '4' });
      t.value = answers[q.key] || '';
      t.addEventListener('input', function () { answers[q.key] = t.value.trim(); setError(s, ''); save(); });
      s.appendChild(t);
      s.appendChild(el('p', { class: 'gb__error', role: 'alert' }));
      s.appendChild(actions(UI.next, function () {
        if (!q.optional && !answers[q.key]) return setError(s, UI.errRequired);
        next();
      }));
    }
    steps.push({ id: q.key, el: s, progress: true, when: q.when });
  });

  // Resultado PRYSM y envío
  (function () {
    var s = stepShell('prysm', UI.scoreEyebrow, UI.scoreTitle);
    s.appendChild(el('p', { class: 'gb__text' }, esc(UI.scoreText)));
    var f = el('div', { class: 'gb__field' });
    var i = el('input', { class: 'gb__input gb__input--score', type: 'text', inputmode: 'numeric', pattern: '[0-9]*', maxlength: '4', 'aria-label': UI.scoreTitle, placeholder: '000' });
    i.value = answers.prysm || '';
    i.addEventListener('input', function () { i.value = i.value.replace(/\D/g, ''); answers.prysm = i.value; setError(s, ''); save(); });
    f.appendChild(i);
    s.appendChild(f);

    var hp = el('div', { class: 'gb__hp', 'aria-hidden': 'true' });
    hp.appendChild(el('input', { type: 'text', name: 'website', tabindex: '-1', autocomplete: 'off', 'data-gb-hp': '' }));
    s.appendChild(hp);

    var c = el('label', { class: 'gb__consent' });
    var cb = el('input', { type: 'checkbox', name: 'consent' });
    cb.checked = !!answers.consentimiento;
    cb.addEventListener('change', function () { answers.consentimiento = cb.checked; setError(s, ''); save(); });
    c.appendChild(cb);
    var ctext = esc(UI.consent);
    if (cfg.privacyUrl) ctext += ' <a href="' + esc(cfg.privacyUrl) + '" target="_blank" rel="noopener">' + esc(UI.privacy) + '</a>';
    c.appendChild(el('span', null, ctext));
    s.appendChild(c);

    var sum = el('p', { class: 'gb__summary', 'data-gb-summary': '' });
    s.appendChild(sum);
    s.appendChild(el('p', { class: 'gb__error', role: 'alert' }));
    var act = actions(UI.send, submit);
    s.appendChild(act);
    steps.push({ id: 'prysm', el: s, progress: true, onShow: function () { sum.textContent = UI.summary + ' ' + (answers.email || '').toLowerCase(); } });
  })();

  // Gracias
  (function () {
    var s = stepShell('done', UI.doneEyebrow, '');
    s.classList.add('gb__done');
    var h = el('h1', { class: 'gb__title', tabindex: '-1', 'data-gb-done-title': '' });
    s.appendChild(h);
    s.appendChild(el('p', { class: 'gb__text' }, esc(UI.doneText)));
    s.appendChild(el('p', { class: 'gb__hint' }, esc(UI.doneText2)));
    s.appendChild(el('p', { class: 'gb__text' }, esc(UI.doneText3)));
    steps.push({ id: 'done', el: s, progress: false });
  })();

  steps.forEach(function (st) { stepsEl.appendChild(st.el); });

  /* Navegación */
  var current = 0;
  var history = [];
  function stepIndex(id) { for (var k = 0; k < steps.length; k++) if (steps[k].id === id) return k; return -1; }
  function visible(st) { return !st.when || st.when(answers); }
  function next() {
    for (var k = current + 1; k < steps.length; k++) if (visible(steps[k])) return go(k);
  }
  function go(k, isBack) {
    if (!isBack && k !== current) history.push(current);
    steps[current].el.classList.remove('is-active');
    current = k;
    var st = steps[k];
    st.el.classList.add('is-active');
    if (st.onShow) st.onShow();
    backBtn.hidden = !(history.length && st.id !== 'done');
    updateProgress();
    var focusEl = st.el.querySelector('h1, h2');
    if (focusEl) focusEl.focus({ preventScroll: true });
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function updateProgress() {
    var list = steps.filter(function (st) { return st.progress && visible(st); });
    var pos = list.indexOf(steps[current]);
    var pct = steps[current].id === 'done' ? 100 : (pos < 0 ? 0 : Math.round((pos / list.length) * 100));
    barEl.style.width = pct + '%';
    countEl.textContent = pos < 0 ? '' : (pos + 1) + ' / ' + list.length;
  }
  backBtn.addEventListener('click', function () { if (history.length) go(history.pop(), true); });

  /* Envío */
  function submit() {
    if (sending) return;
    var s = steps[current].el;
    if (!/^\d{2,4}$/.test(answers.prysm || '')) return setError(s, UI.errScore);
    if (!answers.consentimiento) return setError(s, UI.errConsent);

    var payload = new URLSearchParams();
    ['email', 'nombre', 'apellidos', 'edad', 'sexo', 'ciudad', 'prysm'].forEach(function (k) { payload.append(k, answers[k] || ''); });
    Q.forEach(function (q) { payload.append(q.key, visible({ when: q.when }) ? (answers[q.key] || '') : ''); });
    payload.set('email', (answers.email || '').toLowerCase());
    payload.append('idioma', lang);
    payload.append('consentimiento', 'Sí');
    payload.append('token', cfg.token || '');
    payload.append('segundos', String(Math.round((Date.now() - startedAt) / 1000)));
    var hpVal = (root.querySelector('[data-gb-hp]') || {}).value;
    if (hpVal) payload.append('website', hpVal);

    sending = true;
    var btn = s.querySelector('.gb__btn');
    btn.disabled = true; btn.textContent = UI.sending;
    setError(s, '');

    fetch(cfg.webhook, { method: 'POST', mode: 'no-cors', body: payload })
      .then(function () {
        var name = answers.nombre || '';
        clearStore();
        root.querySelector('[data-gb-done-title]').textContent = UI.doneTitle.replace('{name}', name);
        history = [];
        go(stepIndex('done'));
      })
      .catch(function () {
        sending = false;
        btn.disabled = false; btn.textContent = UI.send;
        setError(s, UI.errNetwork);
      });
  }

  go(0, true);
})();